import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { Checkbox, Collapse } from "antd";
import Icon from "../Icon";
import { UiStretchBox, UiStretchTitle, UiStretchItem } from "./StretchList.style";
/**
 * 可伸展的列表內含checkbox功能呦
 */

const CheckGroup = Checkbox.Group;
const {
  Panel
} = Collapse;

const noop = () => {};

const StretchList = ({
  title = "",
  data = [],
  checkedList = [],
  isCheckType = true,
  onChange = noop,
  className,
  mt,
  mb,
  onClick = noop
}) => {
  const [indeterminate, setIndeterminate] = useState(false);
  const [checkAll, setCheckAll] = useState(false);

  const onChangeHandle = list => {
    onChange(list);
    onClick(...list);
    setIndeterminate(!!list.length && list.length < data.length);
    setCheckAll(list.length === data.length);
  };

  const onCheckAllChangeHandle = e => {
    const list = e.target.checked ? data.map(item => item.value) : [];
    onChange(list);
    onClick(...list);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  const renderIcon = isActive => {
    return /*#__PURE__*/React.createElement(Icon, {
      name: "arrow_drop_up",
      rotate: isActive ? 0 : 180,
      color: "#1890ff"
    });
  };

  useEffect(() => {
    if (checkedList.length === 0) {
      setIndeterminate(false);
      setCheckAll(false);
    } else {
      setIndeterminate(!!checkedList.length && checkedList.length < data.length);
      setCheckAll(checkedList.length === data.length);
    }
  }, [checkedList]);
  return /*#__PURE__*/React.createElement(UiStretchBox, {
    className: className,
    mt: mt,
    mb: mb
  }, /*#__PURE__*/React.createElement(Collapse, {
    expandIcon: ({
      isActive
    }) => renderIcon(isActive)
  }, /*#__PURE__*/React.createElement(Panel, {
    key: "1",
    header: /*#__PURE__*/React.createElement(UiStretchTitle, null, isCheckType && /*#__PURE__*/React.createElement(Checkbox, {
      indeterminate: indeterminate,
      onChange: onCheckAllChangeHandle,
      checked: checkAll,
      onClick: e => {
        e.stopPropagation();
      }
    }), title)
  }, /*#__PURE__*/React.createElement(CheckGroup, {
    value: checkedList,
    onChange: onChangeHandle
  }, data.length > 0 && data.map((item, index) => {
    return /*#__PURE__*/React.createElement(UiStretchItem, {
      key: index
    }, isCheckType ? /*#__PURE__*/React.createElement(Checkbox, {
      value: item.value
    }, item.label) : /*#__PURE__*/React.createElement("span", null, item.label));
  })))));
};

export default StretchList;
StretchList.propTypes = {
  title: PropTypes.string,
  code: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.any
  })).isRequired,
  isCheckType: PropTypes.bool,
  checkedList: PropTypes.array,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  className: PropTypes.string,
  mt: PropTypes.string,
  mb: PropTypes.string
};